/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetConvenienceQueryResponse,
  GetConveniencePathParams,
  GetConvenience404,
} from '../types/GetConvenience'

function getGetConvenienceUrl({
  cstore_id,
}: {
  cstore_id: GetConveniencePathParams['cstore_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/places/convenience/${cstore_id}/` as const,
  }
  return res
}

/**
 * @summary Get a convenience chain
 * {@link /api/v1/places/convenience/:cstore_id/}
 */
export async function getConvenience(
  { cstore_id }: { cstore_id: GetConveniencePathParams['cstore_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetConvenienceQueryResponse,
    ResponseErrorConfig<GetConvenience404>,
    unknown
  >({
    method: 'GET',
    url: getGetConvenienceUrl({ cstore_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
